// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"aea933e3812260d9","7855":"cc8f2086d16d16b3"}[chunkId] + ".css";
};